import React, { useRef } from 'react';
import {
  saveOperationDataDiagram,
  tenantAttributeInfos,
  uploadImageDiagram,
} from '../../pages/Attribute/AttributeSlice';

import { Button } from 'react-bootstrap';
import { Image } from 'react-feather';
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import { convertPdfToImages } from '../../common/PDFResolver';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

const PreviewImage = ({
  deviceId,
  preview,
  setPreview,
  setShowDiagram,
  loading,
}) => {
  const { t } = useTranslation();
  const fileInputRef = useRef();
  const dispatch = useDispatch();
  const token = localStorage.getItem('token');

  const handleImageChange = (e) => {
    const file = e.target.files[0];

    if (file.type !== 'application/pdf') {
      let resolver = () => {};
      let reader = new FileReader();

      reader.onload = function (e) {
        let img = document.createElement('img');
        const sizeW = 1296,
          sizeH = 700;

        img.onload = function (event) {
          // Dynamically create a canvas element
          let canvas = document.createElement('canvas');
          canvas.width = sizeW;
          canvas.height = sizeH;

          let ctx = canvas.getContext('2d');

          // Actual resizing
          ctx.drawImage(img, 0, 0, sizeW, sizeH);

          // Show resized image in preview element
          let dataurl = canvas.toDataURL(file.type);

          resolver(dataurl);
          setPreview(dataurl);
        };
        img.src = e.target.result;
      };

      reader.readAsDataURL(file);
    } else {
      let resolver = () => {};
      convertPdfToImages(file).then((url) => {
        let img = document.createElement('img');
        const sizeW = 1296,
          sizeH = 700;

        img.onload = function (event) {
          // Dynamically create a canvas element
          let canvas = document.createElement('canvas');
          canvas.width = sizeW;
          canvas.height = sizeH;

          let ctx = canvas.getContext('2d');

          // Actual resizing
          ctx.drawImage(img, 0, 0, sizeW, sizeH);

          // Show resized image in preview element
          let dataurl = canvas.toDataURL(file.type);

          resolver(dataurl);
          setPreview(dataurl);
        };
        img.src = url;
      });
      window.console.log = () => {};
    }
  };

  const handleInputClick = (e) => {
    e.preventDefault();
    fileInputRef.current.click();
  };

  const handleSaveImageDiagram = async () => {
    const file = preview;

    const arrMachine = [];
    await dispatch(saveOperationDataDiagram({ token, deviceId, arrMachine }));
    await dispatch(uploadImageDiagram({ token, deviceId, file }));
    dispatch(tenantAttributeInfos({ token }));
    setShowDiagram(true);
  };

  const handleCancelImageDiagram = () => {
    setPreview(null);
    setShowDiagram(true);
  };

  return (
    <>
      <div className="imageUploadContainer">
        <div className="previewWrapper">
          {loading ? (
            <Spin tip="Loading..." indicator={antIcon}>
              <Image className="preview" width={150} />
            </Spin>
          ) : preview ? (
            <>
              <img
                className="preview"
                alt="avatar"
                src={preview}
                onClick={handleInputClick}
              />
              <Button
                id="saveDiagram"
                variant="primary"
                onClick={handleSaveImageDiagram}
              >
                {t('save')}
              </Button>
              <Button
                id="cancelDiagram"
                variant="secondary"
                onClick={handleCancelImageDiagram}
              >
                {t('cancel')}
              </Button>
            </>
          ) : (
            <>
              <Image
                className="preview"
                width={150}
                onClick={handleInputClick}
              />
              <div className="content-preview text-center">
                {t('upload-file')}
              </div>
              <input
                type="file"
                style={{ display: 'none' }}
                ref={fileInputRef}
                onChange={handleImageChange}
              />
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default PreviewImage;
